<template>
    <div class="html-page">
        <div class="html-page-header">
            {{ form.title }}
            <span class="html-page-header-date">{{ form.date }}</span>
        </div>
        <div class="html-page-content" v-html="form.content" />
    </div>

</template>

<script>
    export default {
        name: 'HtmlPage',
        data() {
            return {
                form: {
                    title: '',
                    content: '',
                },
            }
        },
        created() {
            this.getData()
        },
        methods: {
            getData() {
                this.$request
                    .post(
                        `/transformToAfter${this.$route.query.api}`,
                        {
                            id: this.$route.query.id,
                            guid: this.$route.query.guid, // 兼容旧配置
                        },
                        { showLoading: true },
                    )
                    .then((res) => {
                        this.form = res.data || res // 兼容旧配置
                    })
            },
        },
    }
</script>

<style lang="scss">
.html-page{
    &-header{
        position: relative;
        box-shadow: 0px 3px 8px rgba(185, 185, 185, 0.3);
        margin-bottom: 10px;
        font-size: 18px;
        text-align: center;
        padding: 20px 20px 30px 20px;
        &-date{
            position: absolute;
            right: 10px;
            bottom: 10px;
            font-size: 13px;
            color: #696969;
        }
    }
    &-content{
        padding: 15px;
    }
}
</style>
